import axios from 'axios';
import Toast from 'light-toast';
import React, { Component } from 'react';
import {
  FaBell,
  FaBoxOpen,
  FaChartBar,
  FaDollarSign,
  FaFilter,
  FaHome,
  FaLightbulb,
  FaPersonBooth
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Flags from './flags';

import { fetchAuthSession } from 'aws-amplify/auth';

import cookies from '../utils/cookies.util';
import base_url from '../utils/request.util';

const NAVY = '#002850';

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userType: 'Client',
      user_name: cookies.get('User-Specified'),
      code: '',
      suggestions: []
    };

    this.logOutUser = this.logOutUser.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchSuggestions = this.fetchSuggestions.bind(this);
  }

  handleChange(event) {
    let code = event.target.value;
    code = code.toUpperCase();
    this.setState({ code });
  }

  async fetchSuggestions(event) {
    this.setState({ code: event.target.value });
    if (event.target.value === '') {
      this.setState({ suggestions: [] });
      return;
    }

    await fetchAuthSession().then(() => {
      const config = {};
      config.params = { q: event.target.value };
      config.headers = {
        Authorization: cookies.get('Authorization'),
        'User-Specified': cookies.get('User-Specified'),
        'Type-Specified': cookies.get('Type-Specified')
      };

      axios
        .get(`${base_url}/product/suggest`, config)
        .then((res) => {
          this.setState({ suggestions: res.data.items });
        })
        .catch((error) => {
          console.log(error);
          Toast.fail('Error Performing Action', 3000);
        });
    });
  }

  logOutUser() {
    this.props.handleLogout();
  }

  async componentDidMount() {
    this.setState({ userType: cookies.get('Type-Specified') });
  }

  render() {
    const displayName = this.state.user_name && this.state.user_name.split('@')[0];

    return (
      <>
        <nav
          className="navbar navbar-expand-sm fixed-top"
          style={{
            backgroundColor: '#ffffff',
            borderBottom: '1px solid #e2e8f0',
            boxShadow: '0 1px 6px rgba(0, 40, 80, 0.07)',
            padding: '0 16px',
            height: '52px'
          }}>
          {/* Brand */}
          <Link
            className="navbar-brand"
            to="/"
            style={{ color: NAVY, fontWeight: '700', fontSize: '15px', letterSpacing: '-0.2px', marginRight: '24px' }}>
            Project Calculus
          </Link>

          {/* Quote search */}
          <ul className="navbar-nav" style={{ marginRight: 'auto' }}>
            <form className="d-flex" style={{ margin: 0 }}>
              <input
                type="text"
                id="code"
                value={this.state.code}
                className="form-control"
                placeholder="Search quotes…"
                onChange={this.fetchSuggestions}
                autoComplete="off"
                style={{
                  borderRadius: '6px',
                  borderColor: '#d1d5db',
                  fontSize: '13px',
                  height: '32px',
                  width: '180px',
                  padding: '0 10px'
                }}
              />
            </form>
          </ul>

          {/* Nav items */}
          <ul className="navbar-nav ml-auto" style={{ alignItems: 'center' }}>
            {/* Home */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle calc-nav-link"
                href="#"
                id="navbardrop"
                data-toggle="dropdown">
                <FaHome style={{ verticalAlign: 'middle' }} /> Home
              </a>
              <div className="dropdown-menu calc-dropdown">
                <Link className="dropdown-item calc-dropdown-item" to="/options/open-overview">Portfolio Overview</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/options/open-performance">Portfolio Performance</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/options/open-attribution">Portfolio Attribution</Link>
              </div>
            </li>

            {/* Portfolio */}
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle calc-nav-link" href="#" id="navbardrop" data-toggle="dropdown">
                <FaDollarSign style={{ verticalAlign: 'middle' }} /> Portfolio
              </a>
              <div className="dropdown-menu calc-dropdown">
                <Link className="dropdown-item calc-dropdown-item" to="/portfolio/orders">Order Book</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/portfolio/cash">Cash</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/portfolio/bond">Bond</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/portfolio/insights">Insights</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/portfolio/structure">Structure</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/portfolio/funds">Funds</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/portfolio/commodity">Commodity</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/portfolio/others">Others</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/portfolio/all">All</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/portfolio/ledger">Ledger</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/portfolios">Portfolios</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/watchlist">Watchlist</Link>
              </div>
            </li>

            {/* Structure */}
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle calc-nav-link" href="#" id="navbardrop" data-toggle="dropdown">
                <FaBoxOpen style={{ verticalAlign: 'middle' }} /> Structure
              </a>
              <div className="dropdown-menu calc-dropdown">
                <Link className="dropdown-item calc-dropdown-item" to="/structure/autocallable/details">AC Structures</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/autocallable/expired/details">AC Expired Structures</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/autocallable/curated/details">Curated AC Structures</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/dispersion-warrent/details">DW Structures</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/dispersion-warrent/expired/details">DW Expired Structures</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/twin-win/details">Twin Win Structures</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/twin-win/expired/details">Twin Win Expired Structures</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/shark-note/details">Shark Note Structures</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/shark-note/expired/details">Shark Note Expired Structures</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/autocallable/autocall-status">Autocall Status</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/autocallable/matured-risk">Matured Risk</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/autocallable/risk-assesment">Risk Assessment</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/autocallable/underlying">Structure Underlying</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/matrix">Structure Matrix</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/coupon-cashflow">Coupon Cashflow</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/analysis">Structure Analysis</Link>
              </div>
            </li>

            {/* Ideas */}
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle calc-nav-link" href="#" id="navbardrop" data-toggle="dropdown">
                <FaLightbulb style={{ verticalAlign: 'middle' }} /> Ideas
              </a>
              <div className="dropdown-menu calc-dropdown">
                <Link className="dropdown-item calc-dropdown-item" to="/structure/autocallable/ideas">AC Structure Ideas</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/dispersion-warrent/ideas">DW Structure Ideas</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/twin-win/ideas">Twin Win Structure Ideas</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/structure/shark-note/ideas">Shark Note Structure Ideas</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/equity">Equity Ideas</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/bond">Bond Ideas</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/fund">Fund Ideas</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/etf">ETF Ideas</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/index">Index Ideas</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/indices">All Indices</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/bonds">External Bonds</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/index-components?code=GSPC%20INDEX">S&amp;P 500 Weightage</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/index-components-pivot?code=GSPC%20INDEX">S&amp;P 500 Pivot</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/index-components?code=FTSE%20INDEX">FTSE Weightage</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/index-components-pivot?code=FTSE%20INDEX">FTSE Pivot</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/product/etfs">ETF Lists</Link>
              </div>
            </li>

            {/* Options */}
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle calc-nav-link" href="#" id="navbardrop" data-toggle="dropdown">
                <FaChartBar style={{ verticalAlign: 'middle' }} /> Options
              </a>
              <div className="dropdown-menu calc-dropdown">
                <Link className="dropdown-item calc-dropdown-item" to="/options/option-chain">Option Chain</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/options/option-matrix">Option Matrix</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/options/surface-graphs">Surface Graph</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/options/strategy">Options Strategy</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/options/put-writing-strategy">Calculate PWS</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/options/put-writing-strategies/codes">Put Writing Strategy Trades</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/options/call-writing-strategy">Calculate CWS</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/options/call-writing-strategies/codes">Call Writing Strategy Trades</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/options/put-writing-strategies/index?code=GSPC%20INDEX">Put Writing Strategy S&amp;P</Link>
              </div>
            </li>

            {/* Screener */}
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle calc-nav-link" href="#" id="navbardrop" data-toggle="dropdown">
                <FaFilter style={{ verticalAlign: 'middle' }} /> Screener
              </a>
              <div className="dropdown-menu calc-dropdown">
                <Link className="dropdown-item calc-dropdown-item" to="/screener/email">Email</Link>
                <Link className="dropdown-item calc-dropdown-item" to="/screener/equity">Equity</Link>
              </div>
            </li>

            {/* Alerts */}
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle calc-nav-link" href="#" id="navbardrop" data-toggle="dropdown">
                <FaBell style={{ verticalAlign: 'middle' }} />
              </a>
              <div className="dropdown-menu calc-dropdown dropdown-menu-right">
                <Link className="dropdown-item calc-dropdown-item" to="/screener/alert">Alerts</Link>
              </div>
            </li>

            {/* Admin — role-gated */}
            {(this.state.userType === 'Admin' || this.state.userType === 'BackOffice') && (
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle calc-nav-link" href="#" id="navbardrop" data-toggle="dropdown">
                  <FaPersonBooth style={{ verticalAlign: 'middle' }} /> Admin
                </a>
                <div className="dropdown-menu calc-dropdown dropdown-menu-right">
                  <Link className="dropdown-item calc-dropdown-item" to="/structure/autocallable/add">Create Autocallable Structure</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/structure/dispersion-warrent/add">Create Dispersion Warrant Structure</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/structure/twin-win/add">Create Twin Win Structure</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/structure/shark-note/add">Create Shark Note Structure</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/options/analyse">Create Option Sheet</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/product/add-instrument">Create Instrument</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/relationship-management/link-user">Relationship Management</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/portfolio/portfolio-Construction">Portfolio Construction</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/add-user">Add User</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/users">Users</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/link-portfolio">Link Portfolio</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/portfolio/add">Add Order</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/portfolio/asset-mapping">Asset Mapping</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/quote/search">Search Quote</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/structure/autocallable/term-sheet">Term Sheet Upload</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/stock-split">Stock Split</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/login-history">Login History</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/add-login">Create Login</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/upload/planetary-movements">Upload Planetary Movement Sheet</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/upload/bond-price">Upload Bond Price Sheet</Link>
                  <Link className="dropdown-item calc-dropdown-item" to="/planetary-movement">Planetary Movement</Link>
                </div>
              </li>
            )}

            {/* User greeting */}
            <li className="nav-item" style={{ marginLeft: '8px' }}>
              <Link
                className="nav-link"
                to="/profile"
                style={{ color: NAVY, fontSize: '13px', fontWeight: '500', padding: '0 8px' }}>
                Hi, {displayName}
              </Link>
            </li>

            {/* Logout */}
            <li className="nav-item" style={{ marginLeft: '4px' }}>
              <button
                className="btn btn-sm"
                onClick={this.logOutUser}
                style={{
                  backgroundColor: 'transparent',
                  color: '#dc2626',
                  border: '1px solid #fca5a5',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: '500',
                  padding: '3px 12px',
                  cursor: 'pointer'
                }}>
                Logout
              </button>
            </li>
          </ul>
        </nav>

        {/* Quote suggestions dropdown */}
        {this.state.suggestions.length > 0 && (
          <div
            style={{
              position: 'fixed',
              top: '52px',
              left: '160px',
              zIndex: 1050,
              width: '280px'
            }}>
            <ul
              style={{
                listStyle: 'none',
                margin: 0,
                padding: '4px 0',
                backgroundColor: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                boxShadow: '0 8px 24px rgba(0, 40, 80, 0.12)',
                maxHeight: '240px',
                overflowY: 'auto'
              }}>
              {this.state.suggestions.map((value, index) => (
                <a
                  key={index}
                  href={`/product/equity?code=${value.code}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 14px',
                    fontSize: '13px',
                    color: '#1e293b',
                    textDecoration: 'none',
                    borderBottom: index < this.state.suggestions.length - 1 ? '1px solid #f1f5f9' : 'none'
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f8fafc')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}>
                  <span style={{ fontWeight: '600', color: NAVY }}>{value.code}</span>
                  <span style={{ color: '#64748b', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {value.name}
                  </span>
                  <img src={Flags[value.country_iso]} alt="" style={{ width: '16px', flexShrink: 0 }} />
                </a>
              ))}
            </ul>
          </div>
        )}
      </>
    );
  }
}

export default Navbar;
